import { Component, type ReactNode } from 'react';
import { attemptChunkReloadOnce, isChunkLoadError } from './chunkReload';

type Props = {
  children: ReactNode;
  fallback?: ReactNode;
};

type State = {
  error: Error | undefined;
};

export class ChunkLoadErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { error: undefined };
  }

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error): void {
    if (!isChunkLoadError(error)) {
      return;
    }
    attemptChunkReloadOnce(error);
  }

  override render(): ReactNode {
    const { error } = this.state;
    if (!error) {
      return this.props.children;
    }
    if (!isChunkLoadError(error)) {
      throw error;
    }
    return this.props.fallback ?? null;
  }
}
